import moment from 'moment'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Evaluation } from '../service/PerformanceAPI'

export default function EvaluationButton(props) {

    const [evaluationPeriod, setEvaluationPeriod] = useState()
    const [evaluationIndex, setEvaluationIndex] = useState()
    const [evaluationShow, setEvaluationShow] = useState()
    const [evaluationId, setEvaluationId] = useState()



    useEffect(() => {

        loadData()
    }, [])

    const loadData = async () => {
        let res = await Evaluation()
        setEvaluationPeriod(res.data.ResponseData)
        res.data.ResponseData.map((result, i) => {
            if (result.currentEvaluation === "1") {
                setEvaluationIndex(i)
                setEvaluationShow(result)
                setEvaluationId(result.id)
                if (props?.dataChange !== undefined && props?.dataChange !== null) {
                    props.dataChange(result)
                }
            }

        })

    }


    const previousEvaluation = async (value) => {
        let currentIndex = evaluationIndex


        if (currentIndex == 0) {
            currentIndex = (evaluationPeriod.length - 1)
            setEvaluationIndex(currentIndex)
            setEvaluationShow(evaluationPeriod[currentIndex])
            if (props?.dataChange !== undefined && props?.dataChange !== null) {
                props.dataChange(evaluationPeriod[currentIndex])
            }
        }
        else {
            currentIndex -= 1
            setEvaluationIndex(currentIndex)
            setEvaluationShow(evaluationPeriod[currentIndex])
            if (props?.dataChange !== undefined && props?.dataChange !== null) {
                props.dataChange(evaluationPeriod[currentIndex])
            }
        }
        // loadGoalData(evaluationPeriod[currentIndex].id)

    }

    const nextEvaluation = async (value) => {
        let currentIndex = evaluationIndex



        if (currentIndex == (evaluationPeriod.length - 1)) {
            currentIndex = 0
            setEvaluationIndex(currentIndex)
            setEvaluationShow(evaluationPeriod[currentIndex])
            if (props?.dataChange !== undefined && props?.dataChange !== null) {
                props.dataChange(evaluationPeriod[currentIndex])
            }
        }
        else if (value == "next") {
            currentIndex += 1
            setEvaluationIndex(currentIndex)
            setEvaluationShow(evaluationPeriod[currentIndex])
            if (props?.dataChange !== undefined && props?.dataChange !== null) {
                props.dataChange(evaluationPeriod[currentIndex])
            }
        }
        // loadGoalData(evaluationPeriod[currentIndex].id)

    }


    return (
        <div className="btn-group mrp-monthdisplay semibold-text font-12" role="group" aria-label="Basic outlined example">
            <button onClick={() => { previousEvaluation('pre'); }} type="button" data-bs-toggle="tooltip" title="Previous Week" data-bs-placement="bottom" className="btn btn-outline-primary border-0 performance-flip-color"><img src="/Images/eva-Left-arrow.svg" className="flip-arrow-size" /></button>
            {evaluationShow !== {} ? (<button type="button" className="btn btn-outline-primary border-0 performance-flip-color semibold-text font-12">{moment(evaluationShow?.startData).format('MMM, YYYY')}-{moment(evaluationShow?.endDate).format('MMM, YYYY')}</button>) : null}
            <button onClick={() => { nextEvaluation('next'); }} type="button" data-bs-toggle="tooltip" title="Next Week" data-bs-placement="bottom" className="btn btn-outline-primary  border-0 performance-flip-color"><img src="/Images/eva-Right-arrow.svg" className="flip-arrow-size" /></button>
        </div>
    )
}
